import { routes } from '@/app/routing/router'
import { ShopPageView } from './view'

const currentRoute = routes.case

const CasePageRoute = {
  route: currentRoute,
  view: ShopPageView,
}

export { currentRoute, CasePageRoute }
